import { html } from 'lit'
import { IconBase } from './icon-base.js'

class Icon extends IconBase {
  render() {
    return html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        part="svg"
      >
        <path
          d="M3 20.9999H21M4 17.9999H20M6 17.9999V12.9999M10 17.9999V12.9999M14 17.9999V12.9999M18 17.9999V12.9999M12 7.00671L12.0074 6.99997M21 9.99987L14.126 3.88962C13.3737 3.22096 12.9976 2.88663 12.5732 2.75967C12.1992 2.64782 11.8008 2.64782 11.4268 2.75967C11.0024 2.88663 10.6263 3.22096 9.87404 3.88962L3 9.99987H21Z"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `
  }
}
customElements.define('bank-icon', Icon)
